import z from 'zod';

export const commentFormSchema = z.object({
    comment: z
        .string()
        .min(1, "Comment is required")
        .max(75, "This comment exceeds the 75 character limit"),
})